import { ValidationMessage as DigdirValidationMessage, } from "@digdir/designsystemet-react";
import cn from "clsx";
import * as React from "react";
const ValidationMessage = React.forwardRef(({ "data-color": dataColor = "danger", "data-size": dataSize = "md", children, className, ...props }, ref) => {
    return (React.createElement(DigdirValidationMessage, { className: cn("in-validation-message", className), "data-color": dataColor, "data-size": dataSize, ref: ref, ...props }, children));
});
ValidationMessage.displayName = "ValidationMessage";
export { ValidationMessage };
//# sourceMappingURL=validation-message.js.map